import * as React from "react";
import { GroupContainer, GroupTitle } from "./group-container";
import { Part } from "./part";
import { devTools } from "./api-data";

const Profiler = devTools.get("Profiler");
const useDebugValue = devTools.get("useDebugValue");
const StrictMode = devTools.get("StrictMode");

export function DevTools({ scaleItems }) {
  return (
    <GroupContainer>
      <ul className="grid w-full grid-cols-2 grid-rows-2 gap-y-5 gap-x-8 px-5 py-4">
        <Part
          data={useDebugValue}
          name={"useDebugValue"}
          className="row-start-2"
          scaleItems={scaleItems}
        />
        <Part
          className="col-start-2"
          data={Profiler}
          name={"Profiler"}
          scaleItems={scaleItems}
        />
        <Part
          className="col-start-2"
          data={StrictMode}
          name={"StrictMode"}
          scaleItems={scaleItems}
        />
      </ul>

      <GroupTitle>Dev Tools</GroupTitle>
    </GroupContainer>
  );
}
